import type { CSSProperties, ReactNode } from 'react';
import './components.css';

interface BadgeProps {
  children: ReactNode;
  color: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * Status pill: 15% opacity background, full-color text. Always uppercase.
 */
export function Badge({ children, color, className = '', style }: BadgeProps) {
  const merged: CSSProperties = {
    color,
    background: `${color}26`,
    ...style,
  };
  return (
    <span
      className={`iris-badge ${className}`}
      style={merged}
      data-color={color}
    >
      {children}
    </span>
  );
}
